<script lang="ts">
	import type { Snippet } from "svelte";

	let {
		children,
		title,
		description
	}: {
		children: Snippet;
		title: string;
		description: string;
	} = $props();
</script>

<div class="bg-border/25 space-y-6 rounded-lg border p-8">
	<div class="space-y-2">
		<h2
			class="text-primary text-4xl font-semibold tracking-tight text-pretty sm:text-5xl dark:text-white"
		>
			{title}
		</h2>
		<p class="text-lg/8 text-gray-600 dark:text-gray-400">
			{description}
		</p>
	</div>

	{@render children?.()}
</div>
